export const LetterMap = (key) => {
    const LETTER_LIST = {
        'surat_sakit': 'Surat Sakit',
        'surat_sehat': 'Surat Sehat',
        'surat_rujukan_non_bpjs': 'Surat Rujukan non BPJS',
        'surat_persetujuan_tindakan': 'Surat Persetujuan Tindakan',
        'surat_persetujuan_pelepasan_informasi': 'Surat Persetujuan Pelepasan Informasi',
        'surat_resume_medis': 'Surat Resume Medis',
    }

    return LETTER_LIST[key]
}